import Logo from '../logos/simTLK';

export default Logo;
